module.exports = __webpack_public_path__ + "static/media/walking-across-road.86139da0.jpg";